// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"aa03cf56","115":"bc89d652","245":"b1feb539","246":"14f61d1c","311":"eb274b19","334":"dc5c3ac9","427":"136ec135","428":"6c9835e3","452":"aed72b1a","469":"c070fe85","531":"0f5160af","791":"edb0ea2c","844":"64a1e813"}[chunkId] + ".chunk.js";
};